import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
const HomePage = lazy(() => import("@/features/feed/pages/HomePage").then((m) => ({
    default: m.HomePage,
})));
const ShortlistPage = lazy(() => import("@/features/feed/pages/ShortlistPage").then((m) => ({
    default: m.ShortlistPage,
})));
const EventDetailPage = lazy(() => import("@/features/events/pages/EventDetailPage").then((m) => ({
    default: m.EventDetailPage,
})));
const LoginPage = lazy(() => import("@/features/auth/LoginPage").then((m) => ({
    default: m.LoginPage,
})));
const DashboardPage = lazy(() => import("@/features/dashboard/DashboardPage").then((m) => ({
    default: m.DashboardPage,
})));
const AdminQueuePage = lazy(() => import("@/features/admin/AdminQueuePage").then((m) => ({
    default: m.AdminQueuePage,
})));
const AdminDashboardPage = lazy(() => import("@/features/admin/AdminDashboardPage").then((m) => ({
    default: m.AdminDashboardPage,
})));
const AdminLoginPage = lazy(() => import("@/features/auth/AdminLoginPage").then((m) => ({
    default: m.AdminLoginPage,
})));
function PageLoader() {
    return (_jsx("div", { className: "min-h-screen flex items-center justify-center", children: _jsx("div", { className: "w-6 h-6 rounded-full border-2 border-border-subtle border-t-[#9868cc] animate-spin" }) }));
}
export function AppRouter() {
    return (_jsx(BrowserRouter, { basename: import.meta.env.BASE_URL, children: _jsx(Suspense, { fallback: _jsx(PageLoader, {}), children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/shortlist", element: _jsx(ShortlistPage, {}) }), _jsx(Route, { path: "/events/:slug", element: _jsx(EventDetailPage, {}) }), _jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/dashboard/*", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "/admin/login", element: _jsx(AdminLoginPage, {}) }), _jsx(Route, { path: "/admin", element: _jsx(AdminDashboardPage, {}) }), _jsx(Route, { path: "/admin/queue", element: _jsx(AdminQueuePage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }) }));
}
